import React, { useContext, useEffect } from 'react';

// css
import '../../assets/css/Surveys.css';

// reactstrap
import { Col, Row } from 'reactstrap';

// kendo react
import { Dialog } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';

// mui icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// multilingual
import { useLocalization } from '@progress/kendo-react-intl';
import {
    thankYouFeedbackKey,
    mainMessages,
} from '../../assets/text/MultilingualText.js';
import UserContext from '../common/UserContext';

function ThankYouSurvey() {
    const {
        siteLanguageDefault,
        setSurveyState
    } = useContext(UserContext);

    const localization = useLocalization();

    const close = () => {
        setSurveyState(null);
    }

    // auto hide thank you after 2 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            close();
        }, 2000);
        return () => clearTimeout(timer);
    }, [setSurveyState]);

    return (
        <Dialog
            className={"thank-you-survey ksm-dialog"}
            title={" "}
            onClose={close}
            width={"25vw"}
        >
            <Row>
                <Col className={"p-0 d-flex align-items-center justify-content-center"}>
                    <CheckCircleIcon
                        fontSize={"large"}
                        style={{
                            'color': 'var(--color-alert-success-base)'
                        }}
                    />
                    <Label className={"survey-title ms-1"}>
                        <h3 style={{fontWeight: 600}}>
                            {localization.toLanguageString(thankYouFeedbackKey, mainMessages[siteLanguageDefault][thankYouFeedbackKey])}
                        </h3>
                    </Label>
                </Col>
            </Row>
        </Dialog>
    );
}

export default ThankYouSurvey;